<!-- *ngIf will hide the header unless a user has logged on -->

<header *ngIf="userService?.isLoggedOn" class="ot-header-container">
  <div class="ot-header-left">
    <button class="ot-hamburger" (click)="onHamburgerOpen.emit()"></button>
    <a [routerLink]="['/home']" class='ot-home-link'><img class="ot-header-image" alt='OpenText File360'
        src="assets/images/header_file360_li.svg"></a>
  </div>
  <div class="ot-header-center">
    <div class="ot-header-text">{{title}}</div>
  </div>
  <div class="ot-header-right">
    <a title="Help" class="ot-help" [href]="helpUrl" target="_blank" rel="noopener"></a>
    <button title="User menu" class="ot-user" [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger"
      [ngClass]="{'ot-expanded': userMenuTrigger.menuOpen}">{{userService?.currentUser?.initials}}</button>
    <mat-menu #userMenu yPosition="below" class='ot-menu' [overlapTrigger]="false">
      <button mat-menu-item class='ot-menu-item'>{{userService?.currentUser?.fullName}}</button>
      <div class="ot-menu-separator"></div>
      <button mat-menu-item class='ot-menu-item' (click)="openAboutDialog()">About OpenText
        File360</button>
      <div class="ot-menu-separator"></div>
      <button mat-menu-item class='ot-menu-item' (click)="logOff()">Sign out</button>
    </mat-menu>
  </div>
</header>